import { Typography } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import React from 'react';
import Arrow from '../../../../components/icons/arrow.svg?react';
import ZaplifyLogo from '../../../../components/icons/worko-logo.svg';

export const FieldMappingInfoHeader = (props) => (
    <>
        <Typography>
            <b>Field mapping</b>
        </Typography>
        <Typography>Match your CSV columns to Zaplify Fields to complete your import.</Typography>
        <div>
            <DescriptionIcon />
            <Arrow />
            <img alt="zaplify-company-logo" src={ZaplifyLogo} />
        </div>
    </>
);
